import translations from '../localizations/translations.json.js';

// This imported file is created during build from buildLocalizations.js
var languageFallbacks = {
  de: 'de-de',
  en: 'en-ie',
  es: 'es-es',
  fr: 'fr-fr',
  it: 'it-it',
  nl: 'nl-nl'
};
function localize(phrase, locale) {
  try {
    var _translations$locale$;
    var translatedPhrase = (_translations$locale$ = translations[locale.toLowerCase()]) === null || _translations$locale$ === void 0 ? void 0 : _translations$locale$[phrase];
    if (!translatedPhrase) {
      var language = locale.toLowerCase().substring(0, 2);
      translatedPhrase = translations[languageFallbacks[language]][phrase];
    }
    return translatedPhrase;
  } catch (err) {
    return '';
  }
}

export { localize as default };
//# sourceMappingURL=localize.js.map
